<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  >
  </cTable>
</template>

<script>
import {
  getBranchFreight,
  addBranchFreight,
  getAuditLog,
  saveAudit,
  batchRemove,
  getCountryFreight,
} from "@/api/user/branch";

import cTable from "@/base/common/index";
import { getCountry } from "@/api/system/country";
import {
  getTransportMode,
  getOrderType,
  getCompanies,
} from "@/api/user/client";
// import { getUser } from "@/api/user/internal";
// import { getAllClient } from "@/api/user/client";
export default {
  name: "branch",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        list: getBranchFreight,
        getCountryFreight,
        getCountry,
        getTransportMode,
        getOrderType,
        getCompanies,
        addBranchFreight,
        getAuditLog,
        batchRemove,
        saveAudit,
        // getUser,
        // getAllClient
      },
      config: {},
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("addBranchFreight", row)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            title: this.$t("bind") + this.$t("bindFreight"),
            formBind: {
              labelWidth: 130,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              company_id: [
                {
                  required: true,
                  type: "array",
                  message: "company cannot be empty",
                  trigger: "change",
                },
              ],
              from_country: [
                {
                  required: true,
                  message: "from_country cannot be empty",
                  trigger: "change",
                },
              ],
              to_country: [
                {
                  required: true,
                  message: "to_country cannot be empty",
                  trigger: "change",
                },
              ],
              quotation_id: [
                {
                  required: true,
                  type: "number",
                  message: "freight cannot be empty",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            { company_id: 24 },
            { from_country: 24 },
            { to_country: 24 },
            { quotation_id: 24 },
            { type: 24 },
            // { transport_mode: 24 },
            { is_smsa: 24 },
            { cod_type: 24 },
            { self_pick_up: 24 },
          ],
          fields: [
            {
              name: () => this.$t("shipper_company_cn"),
              key: "company_id",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("shipper_company_cn");
              },
              options: [],
              config: { label: "title", value: "id" },
              bind: {
                multiple: true,
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCompanies", {
                      type: 2,
                    })
                  ).payload;
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("from_country"),
              key: "from_country",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("from_country");
              },
              options: [],
              config: { label: "code", value: "code" },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCountry", {
                      allow_depart: 1,
                    })
                  ).payload.rows;
                  this.$forceUpdate();
                },
                async "on-change"({ fields, row }) {
                  if (!row.from_country) {
                    row.quotation_id = "";
                    row.transport_mode = "";
                  }
                  if (row.from_country && row.to_country) {
                    let data = {
                      fromCountry: row.from_country,
                      toCountry: row.to_country,
                      type: row.type,
                    };
                    let modeList = [];
                    let freightList = [];
                    if (row.type) {
                      modeList = (
                        await this.$page.handleRequestMethods(
                          "getTransportMode",
                          data
                        )
                      ).payload.rows;
                    }
                    freightList = (
                      await this.$page.handleRequestMethods(
                        "getCountryFreight",
                        data
                      )
                    ).payload;
                    fields.forEach((field) => {
                      if (field.key == "quotation_id")
                        field.options = freightList;
                      if (field.key == "transport_mode")
                        field.options = modeList;
                    });
                  }
                },
              },
            },
            {
              name: () => this.$t("target_country"),
              key: "to_country",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("target_country");
              },
              options: [],
              config: { label: "code", value: "code" },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCountry", {
                      allow_arrive: 1,
                    })
                  ).payload.rows;
                  this.$forceUpdate();
                },
                async "on-change"({ fields, row }) {
                  if (!row.to_country) {
                    row.quotation_id = "";
                    row.transport_mode = "";
                  }
                  if (row.from_country && row.to_country) {
                    let data = {
                      fromCountry: row.from_country,
                      toCountry: row.to_country,
                      type: row.type,
                    };
                    let modeList = [];
                    let freightList = [];
                    if (row.type) {
                      modeList = (
                        await this.$page.handleRequestMethods(
                          "getTransportMode",
                          data
                        )
                      ).payload.rows;
                    }
                    freightList = (
                      await this.$page.handleRequestMethods(
                        "getCountryFreight",
                        data
                      )
                    ).payload;
                    fields.forEach((field) => {
                      if (field.key == "quotation_id")
                        field.options = freightList;
                      if (field.key == "transport_mode")
                        field.options = modeList;
                    });
                  }
                },
              },
            },
            {
              name: () => this.$t("freightName"),
              key: "quotation_id",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("freightName");
              },
              options: [],
              config: { label: "title", value: "id" },
              disabled({ row }) {
                return !row.from_country || !row.to_country;
              },
            },
            {
              name: () => this.$t("order_type_t"),
              key: "type",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("order_type_t");
              },
              options: [],
              config: { label: "name", value: "value" },
              default: -1,
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getOrderType")
                  ).payload;
                  this.$forceUpdate();
                },
                async "on-change"({ fields, row }) {
                  if (row.from_country && row.to_country) {
                    let data = {
                      fromCountry: row.from_country,
                      toCountry: row.to_country,
                      type: row.type,
                    };
                    let modeList = [];
                    if (row.type) {
                      modeList = (
                        await this.$page.handleRequestMethods(
                          "getTransportMode",
                          data
                        )
                      ).payload.rows;
                    }
                    fields.forEach((field) => {
                      if (field.key == "transport_mode")
                        field.options = modeList;
                    });
                  }
                },
              },
            },
            {
              name: () => this.$t("transport_mode"),
              key: "transport_mode",
              component: "Select",
              options: [],
              config: {
                label({ row }) {
                  return row.channel_code + "-" + row.channel_name;
                },
                value: "channel_code",
              },
              disabled({ row }) {
                return !row.from_country || !row.to_country;
              },
              placeholder() {
                return this.$t("select") + this.$t("transport_mode");
              },
            },
            {
              name: () => "Is Smsa",
              key: "is_smsa",
              component: "Radio",
              options: [
                { label: this.$t("YES"), value: 1 },
                { label: this.$t("NO"), value: 0 },
              ],
              bind: {
                border: true,
              },
              default: 0,
              // config: {
              //   label({ row }) {
              //     return row.channel_code + "-" + row.channel_name;
              //   },
              //   value: "channel_code"
              // },
              // disabled({ row }) {
              //   return !row.fromCountry || !row.targetCountry;
              // },
              // placeholder() {
              //   return this.$t("select") + this.$t("transport_mode");
              // }
            },
            {
              name: () => this.$t("cod_type"),
              key: "cod_type",
              component: "Select",
              options: [],
              placeholder() {
                return this.$t("select") + this.$t("cod_type");
              },
              methods: {
                async list({ field }) {
                  field.options = await this.$sel.getData("COD_TYPE");
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("PickUpType"),
              key: "self_pick_up",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("PickUpType");
              },
              options: [
                { label: this.$t("self_mention"), value: 1 },
                { label: this.$t("HomeDelivery"), value: 2 },
              ],
              bind: {
                border: true,
              },
            },
          ],
        },
        audit: {
          methods: {
            ok({ row, close }) {
              delete row.create_time;
              delete row.do_action;
              delete row.operator_name;
              this.$page.handleRequestMethods("saveAudit", row).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
            cancel() {
              this.isShow = true;
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 130,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              status: [
                {
                  required: true,
                  message: "status cannot be empty",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            { operator_name: 24 },
            { create_time: 24 },
            { do_action: 24 },
            { status: 24 },
            { remarks: 24 },
          ],
          fields: [
            {
              name: () => this.$t("createTime"),
              key: "create_time",
              component: "Input",
              disabled: true,
              placeholder() {
                return this.$t("enter") + this.$t("createTime");
              },
            },
            {
              name: () => this.$t("operate"),
              key: "operator_name",
              component: "Input",
              disabled: true,
              placeholder() {
                return this.$t("enter") + this.$t("operate");
              },
            },
            {
              name: () => this.$t("operation"),
              key: "do_action",
              component: "Radio",
              options: [
                {
                  label: this.$t("unbind"),
                  value: "remove",
                  disabled() {
                    return true;
                  },
                },
                {
                  label: this.$t("bind"),
                  value: "add",
                  disabled() {
                    return true;
                  },
                },
              ],
              bind: { border: true },
            },
            {
              name: () => this.$t("exlType"),
              key: "status",
              component: "Radio",
              options: [
                {
                  label: this.$t("through"),
                  value: "YES",
                  disabled() {
                    return !this.$modal.isShow;
                  },
                },
                {
                  label: this.$t("not_through"),
                  value: "NO",
                  disabled() {
                    return !this.$modal.isShow;
                  },
                },
              ],
              default: "YES",
              bind: {
                border: true,
              },
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
              disabled() {
                return !this.$modal.isShow;
              },
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
          ],
          footer: {
            show() {
              return this.isShow && this.$hasPermission(603);
            },
          },
        },
      },
      header: {
        searchs: [
          {
            key: "company_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("company_name");
            },
            clearable: true,
            options: [],
            config: { label: "title", value: "id" },
          },
          {
            key: "from_country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("from_country");
            },
            clearable: true,
            options: [],
            optionsFn: "formCountry",
            config: { label: "code", value: "code" },
          },
          {
            key: "to_country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("target_country");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning",
              },
              id: 602,
            },
            {
              name: () => this.$t("unbind"),
              type: "unbind",
              fnName: "unbind",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-trash",
                type: "error",
              },
              id: 605,
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open();
            },
            unbind() {
              let data = {
                id: this.selectAll.map((item) => item.id),
              };
              this.$Modal.confirm({
                title: this.$t("batch") + this.$t("unbind"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("batchRemove", data).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
        },
        // {
        //   name: () => this.$t("clientName"),
        //   key: "account",
        //   align: "left",
        //   minWidth: 80
        // },
        {
          name: () => this.$t("shipper_company_cn"),
          key: "company_name",
          align: "left",
          minWidth: 100,
        },
        // {
        //   name: () => this.$t("salesman"),
        //   key: "salesman_account",
        //   align: "left",
        //   minWidth: 80
        // },
        {
          name: () => this.$t("freightName"),
          key: "title",
          align: "left",
          minWidth: 300,
        },
        {
          name: () => this.$t("auditOrder") + this.$t("exlType"),
          minWidth: 80,
          render: (h, { row }) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type:
                      row.audit_status == 10
                        ? "error"
                        : row.audit_status == 0
                        ? "default"
                        : row.audit_status == 20
                        ? "warning"
                        : "primary",
                    size: "small",
                    disabled:
                      row.audit_status == 0 || !this.$hasPermission(604),
                  },
                  on: {
                    click: () => {
                      this.$refs["table"]
                        .handleRequestMethods("getAuditLog", row.id)
                        .then((res) => {
                          console.log(res);

                          let data = {
                            id: row.id,
                            aid: res.payload.id,
                            do_action: res.payload.do_action,
                            operator_name: res.payload.operator_name,
                            create_time: res.payload.create_time,
                            status:
                              res.payload.status == 20
                                ? "YES"
                                : res.payload.status == 30
                                ? "NO"
                                : "",
                            remarks: res.payload.audit_msg,
                          };
                          this.$refs["table"]
                            .getModal("audit")
                            .open(data, function () {
                              this.isShow =
                                res.payload.status == 10 ? true : false;
                              this.setTitle(this.$t("auditOrder"));
                            });
                        });
                      // row.remarks = "";
                      // this.$refs["table"]
                      //   .getModal("add")
                      //   .open(row, function () {
                      //     //     this.temp = row.audit_status == 30 ? false : true;
                      //     //     this.setTitle(
                      //     //       this.$t("auditOrder") + "(" + row.account + ")"
                      //     //     );
                      //   });
                    },
                  },
                },
                row.audit_status == 10
                  ? this.$t("wait") + this.$t("auditOrder")
                  : row.audit_status == 0
                  ? this.$t("normal")
                  : row.audit_status == 20
                  ? this.$t("through")
                  : this.$t("not_through")
              ),
            ]);
          },
          // key: "audit_status",
          // component: "Button",
          // bind: {
          //   type: "error",
          //   size: "small"
          // },
          // disabled({ row }) {
          //   return row.audit_status == 0;
          // },
          // methods: {
          //   render({ value }) {
          //     return value == 0 ? "正常" : "待审核";
          //   },
          //   click({ row }) {
          //     this.$page
          //       .handleRequestMethods("readBindFreight", row.id)
          //       .then(res => {
          //         let data = {
          //           id: row.id,
          //           aid: res.payload.id,
          //           do_action: res.payload.do_action,
          //           operator_name: res.payload.operator_name,
          //           create_time: res.payload.create_time,
          //           status: "",
          //           remarks: ""
          //         };
          //         this.$page.getModal("add").open(data);
          //       });
          //   }
          // }
        },
        {
          name: () => this.$t("PickUpType"),
          key: "self_pick_up",
          minWidth: 95,
        },
        {
          name: () => "Is Smsa",
          key: "is_smsa",
          minWidth: 95,
          methods: {
            render({ value }) {
              return value == 1 ? this.$t("YES") : this.$t("NO");
            },
          },
        },
        {
          name: () => this.$t("cod_type"),
          key: "cod_type",
          minWidth: 95,
        },
        {
          name: this.$t("country_t"),
          children: [
            {
              name: () => this.$t("from_country"),
              key: "from_country",
              minWidth: 95,
            },
            {
              name: () => this.$t("target_country"),
              key: "to_country",
              minWidth: 95,
            },
          ],
        },
        {
          name: this.$t("tax_fee"),
          children: [
            {
              name: () => this.$t("duty_rate"),
              key: "duty_rate",
              minWidth: 95,
            },
            {
              name: () => this.$t("threshold1"),
              key: "duty_threshold",
              minWidth: 80,
            },
            {
              name: () => this.$t("document_fee"),
              key: "paper_fee",
              minWidth: 110,
            },
          ],
        },
        {
          name: this.$t("currency_t"),
          children: [
            {
              name: () => this.$t("freight_fees"),
              key: "express_currency",
              minWidth: 95,
            },
            {
              name: () => this.$t("taxFee"),
              key: "tax_currency",
              minWidth: 80,
            },
          ],
        },
        {
          name: () => this.$t("convert_rate"),
          key: "convert_rate",
          minWidth: 95,
        },
        {
          name: () => this.$t("transport_method"),
          key: "transport_code_txt",
          minWidth: 95,
        },
        {
          name: this.$t("numMax") + this.$t("accept"),
          children: [
            {
              name: () => this.$t("Weight"),
              key: "max_weight",
              minWidth: 95,
            },
            {
              name: () => this.$t("DeclaredValue"),
              key: "max_values",
              minWidth: 95,
            },
          ],
        },
        {
          name: () => this.$t("remote_regions_fee"),
          key: "remote_regions_fee",
          minWidth: 95,
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          minWidth: 95,
        },
      ],
    };
  },
  mounted() {
    this.header.searchs.forEach(async (item) => {
      if (item.key === "company_id")
        item.options = (await getCompanies()).data.payload;
      if (item.key === "to_country")
        item.options = (
          await getCountry({ allow_arrive: 1 })
        ).data.payload.rows;
    });
  },
};
</script>
